window.addEventListener('DOMContentLoaded', () => {
    const popUp = document.querySelector('.pop-up');

    if (!popUp) {
        return;
    }

    const buttonClose = popUp.querySelector('.pop-up__close');
    buttonClose.addEventListener('click', () => popUp.style.display = 'none');
    const buttonMain = popUp.querySelector('.ns-button');

    if (buttonMain.localName === 'button') {
        buttonMain.addEventListener('click', () => {
            buttonClose.click();
            document.querySelector('.ns-footer-subscribe .ns-button').click();
        });
    }

    setTimeout(() => popUp.style.display = 'block', popUp.dataset.timeout);
});
